import request from './request'

// 实时数据折线图
export const getdataChannelData =(gateway_uuid,channelid,dateset)=>request({
    url:'Gatewaydata/getdata_channel',
    params:{
        gateway_uuid,
        channelid,
        dateset
    },
    method:'post'
})


// 获取默认摄像头信息
export const Camers_Dom = (data)=>request({
    url:'Monitor/getdata_index',
    params:data,
    method:'post'
})
// 获取摄像头信息
export const Camers_Data = (data)=>request({
    url:'Monitor/getdata',
    params:data,
    method:'post'
})

//添加摄像头 更新摄像头

export const Add_Camers = (data)=>request({
    url:'Monitor/updatedata',
    params:data,
    method:'post'
})

//关联所有区域摄像头

export const city_she_xiang_tou = (data)=>request({
    url:'Gatewayinfo/monitor_set',
    method:'post',
    params:data,

})

// 摄像头令牌
export const cameraSetting_Data = ()=>request({
    url:'Monitordata/get_video_token',
    params:{},
    method:'post'
})

// 摄像头开始旋转

export const camerXuan_zhuan = (data)=>request({
    url:'Monitordata/start',
    params:data,
    method:'post'
})

// 停止旋转
export const camer_stop = (data)=>request({
    url:'Monitordata/stop',
    params:data,
    method:'post'
})

// 摄像头水印

export const shui_Camer_TMD = (data)=>request({
    url:'Monitordata/osdset',
    params:data,
    method:'post'
})

// 摄像头翻转
export const Fanzhuan_camer = (data)=>request({
    url:'Monitordata/mirror',
    params:data,
    method:'post'
})

// 获取抓拍数据
export const Zhua_pai_camer = (data)=>request({
    url:'Monitordata/getdata',
    params:data,
    method:'post'
})
// 抓拍数据
export const zhuaPai_smd = (data)=>request({
    url:'Monitordata/get_capture',
    params:data,
    method:'post'
})
// 布防和撤防
export const CheFanf_Came = (data)=>request({
    url:'Monitordata/defenceset',
    params:data,
    method:'post'
})

// 录像
export const luXinag_camser = (data)=>request({
    url:'Monitordata/enable',
    params:data,
    method:'post'
})


// ---------------------------------------------------------------------控制api-----------------------------------------

//获取用电设备信息
export const CamanetSet = (data)=>request({
    url:'Electric/getdata',
    params:data,
    method:'post'
}) 

// 修改和添加设备信息

export const AddHnnds = (data)=>request({
    url:'Electric/updatedata',
    params:data,
    method:'post'
})

// 1.86获取继电器信息
export const listTableScont = (data)=>request({
    url:'Controlpanel/getdata',
    params:data,
    method:'post'
})

// 更新继电器信息和修改

export const EditHnadList = (data)=>request({
    url:'Controlpanel/updatedata',
    params:data,
    method:'post'

})
// 1.90查询继电器开关状态
export const seetHandDatas = (data)=>request({
    url:'Controlpanel/queryrealaystate',
    params:data,
    method:'post'
})
// 继电器开关
export const swithchNameInfo = (data)=>request({
    url:'Controlpanel/postrealaystate',
    params:data,
    method:'post'
})
// 操作日志
export const CaoZuoRiList = (data)=>request({
    url:'Controlpanel/get_actionlog',
    params:data,
    method:'post'
})

// 获取网关路数
export const wangGuan_sun = (data)=>request({
    url:'Controlpanel/get_emptyroadid',
    params:data,
    method:'post'
})
// 行程量百分比
export const xingListBing = (data)=>request({
    url:'Controlpanel/postroutevalue',
    params:data,
    method:'post'
})